import type { THandoverSetting } from '@conversed/shared/src/internal/models/app-config.type';
import { useCallback } from 'react';

import { client } from '../../../api/rest/client';
import { Actions } from '../../../constants/actionTypes';
import { toastErrorTranslated } from '../../../helpers/toast';
import { useMainDispatch } from '../../useMainDispatch';

export const useAvailabilitiesAction = () => {
  const dispatch = useMainDispatch();

  const getAvailabilities = useCallback(async () => {
    try {
      const { data: availabilities } =
        await client.handover.getHandoverConfig();
      dispatch({
        type: Actions.SET_AVAILABILITIES,
        payload: availabilities,
      });
      return 'success';
    } catch (error) {
      console.error(error);
      toastErrorTranslated(error);
      return 'error';
    }
  }, [dispatch]);

  const updateAvailabilities = useCallback(
    async (data: THandoverSetting[]) => {
      try {
        dispatch({ type: Actions.SET_UI, payload: { isLoading: true } });
        await client.handover.updateHandoverConfig({ body: data });
        dispatch({ type: Actions.SET_AVAILABILITIES, payload: data });
      } catch (error) {
        console.error(error);
        toastErrorTranslated(error);
      } finally {
        dispatch({ type: Actions.SET_UI, payload: { isLoading: false } });
      }
    },
    [dispatch],
  );

  const setSelectedDate = (data: string) => {
    dispatch({ type: Actions.SET_SELECTED_DATE, payload: data });
  };

  const setFilter = (data: string) => {
    dispatch({ type: Actions.SET_CALENDAR_FILTER, payload: data });
  };

  const setCalendarView = (data: string) => {
    dispatch({ type: Actions.SET_CALENDAR_VIEW, payload: data });
  };

  return {
    updateAvailabilities,
    getAvailabilities,
    setSelectedDate,
    setFilter,
    setCalendarView,
  };
};
